import { render, staticRenderFns } from "./ClientMenuItem.vue?vue&type=template&id=d05ca75c&scoped=true&"
import script from "./ClientMenuItem.vue?vue&type=script&lang=js&"
export * from "./ClientMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientMenuItem.vue?vue&type=style&index=0&id=d05ca75c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05ca75c",
  null
  
)

export default component.exports